import React, { ReactElement, useEffect, useState, useRef } from 'react';
import cx from 'classnames';
import { MESSAGES } from '../../data';
import { Pause, PlayArrow } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

import './MiniPlayer.scss';

interface Props {
  activePlayerKey: string;
  isFocusable: boolean;
  label?: string;
  playerKey: string;
  setActivePlayerKey: Function;
  src: string;
}

export function MiniPlayer({
  activePlayerKey,
  isFocusable,
  label,
  playerKey,
  setActivePlayerKey,
  src,
}: Props): ReactElement {
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (activePlayerKey !== playerKey) {
      audioElement.current.pause();
      audioElement.current.currentTime = 0;
      setIsPlaying(false);
    }
  }, [activePlayerKey, playerKey]);

  const handleClick = () => {
    if (isPlaying) {
      audioElement.current.pause();
      setIsPlaying(false);
      return;
    }
    setIsPlaying(true);
    audioElement.current.play();
    setActivePlayerKey(playerKey);
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };

  const audioElement = useRef<HTMLAudioElement>(null);

  return (
    <div
      className={cx('mini-player', {
        'mini-player--playing': isPlaying,
      })}
    >
      <audio src={src} ref={audioElement} onEnded={handleEnded}></audio>
      <IconButton onClick={handleClick} tabIndex={isFocusable ? 0 : -1}>
        {isPlaying ? (
          <Pause titleAccess={`${MESSAGES.ACTION_PAUSE} ${label}`} />
        ) : (
          <PlayArrow titleAccess={`${MESSAGES.ACTION_PLAY} ${label}`} />
        )}
      </IconButton>
      {label}
    </div>
  );
}
